<script setup>
  import { Trash, Plus } from "lucide-vue-next";
  import { Input } from "@/components/ui/input";
  import { Button } from "@/components/ui/button";
  import { Label } from "@/components/ui/label";
  import { useProfileUrlParamsStore } from "@stores/survey/profiles/profileUrlParams";
  import { storeToRefs } from "pinia";

  const profileUrlParamsStore = useProfileUrlParamsStore();
  const { currentUrlParams } = storeToRefs(profileUrlParamsStore);
  const { addUrlParam, removeUrlParam } = profileUrlParamsStore;
</script>

<template>
  <div class="space-y-2">
    <Label>URL parameters</Label>

    <div
      v-if="currentUrlParams.length > 0"
      class="grid grid-cols-[1fr_1fr_auto] gap-2">
      <span class="text-xs font-medium text-muted-foreground">Name</span>
      <span class="text-xs font-medium text-muted-foreground">Value</span>
      <span></span>

      <template
        v-for="(item, index) in currentUrlParams"
        :key="`profile-url-param-${index}`">
        <Input
          v-model="item.name"
          placeholder="pid" />
        <Input
          v-model="item.value"
          placeholder="12482" />
        <Button
          variant="ghost"
          size="icon"
          @click="removeUrlParam(index)">
          <Trash class="h-4 w-4" />
        </Button>
      </template>
    </div>

    <Button
      variant="outline"
      @click="addUrlParam">
      <Plus class="h-4 w-4" />
      Add a URL parameter
    </Button>
  </div>
</template>
